(function (Drupal, $, once) {
  Drupal.behaviors.sticky_nav = {
    attach: function (context) {
      $(function() {
        var sectionList = [];

        setTimeout(() => {
          $('.sticky-nav__wrapper').fadeIn(300);
        }, 500);

        if($('.flag.flag-favorite').length && !($('.sticky-nav__favorite .flag').length)) {
          $('.sticky-nav__content .sticky-nav__favorite').append($('.flag.flag-favorite'));
        }

        once('sticky-nav-download', $('.sticky-nav__download')).forEach(function(element) {
          $(element).on('click', function(){
            window.print();
          });
        });

        once('sticky-nav-scroll', $('.sticky-nav__scroll')).forEach(function(element) {
          $(element).on('click', function(){
            $("html, body").scrollTop(0);
          });
        });

        once('webform-submission-guideline', $('.webform-submission-guideline-and-general-feedback-form')).forEach(function(element) {
          $(element).closest('.block-webform-block').prependTo('.sticky-nav__content');
        });

        if(!$('.webform-submission-guideline-and-general-feedback-form').closest('.block-webform-block').children('.close-webform').length) {
          $('.webform-submission-guideline-and-general-feedback-form').closest('.block-webform-block').append('<div class="close-webform"></div>');
        }

        if($('.webform-submission-guideline-and-general-feedback-form .webform-confirmation').length) {
          $('.webform-submission-guideline-and-general-feedback-form').closest('.block-webform-block').addClass('webform-confirmation');
        }

        once('sticky-nav-comment', $('.sticky-nav__comment')).forEach(function(element) {
          $(element).on('click', function(e) {
            var $this = $(this);
            var webform = $this.siblings('.block-webform-block');

            if(!$this.hasClass('is-open') && $(window).width() > 1023) {
              var windowHeight = $(window).height();
              var height = $('.webform-submission-guideline-and-general-feedback-form').closest('.block-webform-block').outerHeight();
              var offsetTop = $('.sticky-nav__content').offset().top;
              var diff = 0;

              if((windowHeight - height - (offsetTop - $(document).scrollTop())) < 0) {
                diff = Math.abs(windowHeight - height - (offsetTop - $(document).scrollTop())) + 32;
                $('.webform-submission-guideline-and-general-feedback-form').closest('.block-webform-block').css('transform', 'translateY(-'+diff+'px)');
              }
              else if ((windowHeight - height - (offsetTop - $(document).scrollTop())) < 32) {
                diff = 32 - windowHeight - height - (offsetTop - $(document).scrollTop());
                $('.webform-submission-guideline-and-general-feedback-form').closest('.block-webform-block').css('transform', 'translateY(-'+diff+'px)');
              }
            }

            $this.toggleClass('is-open');
            webform.stop().fadeToggle(300);
          });
        });

        once('feedback-popup', $("#feedback-popup")).forEach(function(element) {
          $(element).on("click touchstart", function (e) {
            e.preventDefault();
            var $this = $(this);
            var webform = $(".sticky-nav__content>.block-webform-block");

            if ($(window).width() < 1024) {
              $(".hamburger-menu__wrapper").removeClass("active");
              $("#block-msfmg-main-menu").stop().slideUp(300);
            }

            if (!$this.hasClass("opened") && $(window).width() > 1023) {
              var windowHeight = $(window).height();
              var height = $(".webform-submission-guideline-and-general-feedback-form")
                .closest(".block-webform-block")
                .outerHeight();
              var offsetTop = $(".sticky-nav__content").offset().top;
              var diff = 0;

              if (
                windowHeight - height - (offsetTop - $(document).scrollTop()) <
                0
              ) {
                diff =
                  Math.abs(
                    windowHeight - height - (offsetTop - $(document).scrollTop())
                  ) + 32;
                $(".webform-submission-guideline-and-general-feedback-form")
                  .closest(".block-webform-block")
                  .css("transform", "translateY(-" + diff + "px)");
              } else if (
                windowHeight - height - (offsetTop - $(document).scrollTop()) <
                32
              ) {
                diff =
                  32 -
                  windowHeight -
                  height -
                  (offsetTop - $(document).scrollTop());
                $(".webform-submission-guideline-and-general-feedback-form")
                  .closest(".block-webform-block")
                  .css("transform", "translateY(-" + diff + "px)");
              }
            }

            $this.toggleClass("opened");
            $(".sticky-nav__comment").toggleClass("is-open");
            webform.stop().fadeToggle(300);
          });
        });

        once('close-webform', $('.sticky-nav__content .close-webform')).forEach(function(element) {
          $(element).on('click', function(){
            $(this).closest('.block-webform-block').stop().fadeOut(300);
            $('.sticky-nav__comment').removeClass('is-open');
          });
        });

        //Flag functions
        $(document).ajaxStop(function() {
          if($('.sticky-nav__favorite .flag.flag-favorite>.js-flag-message').length) {
            if ($('.sticky-nav__content > .favorite-message').length) {
              favoriteMsgShow();
            }
            else {
              var text = $('.sticky-nav__favorite .flag.flag-favorite>.js-flag-message').text();
              if(text) {
                $('.sticky-nav__content').prepend('<div class="favorite-message"><div class="message"></div> <div class="close"></div></div>');
                $('.sticky-nav__content>.favorite-message>.message').html(text);
                favoriteMsgShow();
              }
            }
          }
        });

        $('.sticky-nav__content >.favorite-message >.close').on('click', function() {
          favoriteMsgHide();
        });

        function favoriteMsgShow() {
          if($('.sticky-nav__content >.sticky-nav__favorite >.flag.action-unflag').length) {
            $('.sticky-nav__content > .favorite-message').fadeIn(300);
          }
          else {
            favoriteMsgHide();
          }
        }

        function favoriteMsgHide() {
          $('.sticky-nav__content > .favorite-message').fadeOut(300);
        }

      });
    }
  }
})(Drupal, jQuery, once);
